import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { formatNumberForLocale } from 'bundles/search-common/utils/utils';

import _t from 'i18n!nls/search-common';

type Props = {
  hitsDisplayedCount: number;
  hitsTotalCount: number;
};

export const EndOfResults = (props: Props): React.ReactElement => {
  const { hitsDisplayedCount, hitsTotalCount } = props;
  const experimentalCountsText = _t('Showing #{currentCount} of #{totalCount}', {
    currentCount: formatNumberForLocale(hitsDisplayedCount),
    totalCount: formatNumberForLocale(hitsTotalCount),
  });
  return (
    <Typography2
      component="p"
      variant="bodyPrimary"
      css={{
        textAlign: 'center',
        marginTop: 'var(--cds-spacing-200)',
        marginBottom: 'var(--cds-spacing-600)',
        color: `var(--cds-color-neutral-primary-weak)`,
      }}
    >
      {experimentalCountsText}
    </Typography2>
  );
};

export default EndOfResults;
